import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { withTranslation } from 'react-i18next';

import RightSide from './RightSide';
import Footer from './Footer';

class BadBrowser extends Component {
    constructor(props) {
        super(props)

        this.state = {

        }
    }

    render() {
        const { t } = this.props;

        return (
            <div className="main badBrowser">
                <Helmet>
                    <title>{this.props.whitemarkTitle}</title>
                    {<link rel="shortcut icon" href={this.props.whitemarkFavicon} />}
                    <style type="text/css">
                        {`
                            .main {
                                background:url(${this.props.whitemarkBackground});
                                background-size:cover;
                            }

                            .main>div.darker{
                                background-color: rgba(32,32,48,0.7);
                                min-height: 100vh;
                            }

                            button.orangeBtn {
                                background-color: ${this.props.whitemarkBtnColor};
                            }

                            .logoPrincipal {
                                background-image: url(${this.props.whitemarkLogo});
                            }
                        `}
                    </style>
                </Helmet>
                <div className={this.props.whitemarkTitle === "LockSelf Files Transfer" ? "darker" : "noDark"}>
                    <div className="row">
                        <div className="mColumn">
                            <div className="logoPrincipal">&nbsp;</div>
                            <div className="bigCard">
                                <div className="Central">
                                    <div className="errorCard">
                                        <div>
                                            <span>{t("error.oops")}</span>
                                        </div>
                                        <h2>{t("deviceBrowser.notRunningTitle")}</h2>
                                        <p>{t("deviceBrowser.notRunningMsg")}</p>
                                    </div>
                                </div>
                            </div>
                            <Footer />
                        </div>
                        <RightSide transferIsAvailable={false} />
                    </div>
                </div>
            </div>
        )
    }
}

export default withTranslation()(BadBrowser)
